import {createApp} from 'vue';
import selectParcels from './components/select-parcels';
import quotForm from './components/quot-form.vue';
import orderForm from './components/order-form.vue';

const app = createApp({
    components: {
        'select-parcels': selectParcels,
        'quot-form': quotForm,
        'order-form': orderForm
    }
});

app.mount('#quot-panel');
